// Not sure if this belongs here or elsewhere, but it's as good as any for now.

const copyOptions = [
  {
    value: 'acceptAnyDate',
    label: 'Accept Any Date',
    toolTip: 'Allow any, even invalid, date formats',
    enabledByDefault: true,
  },
  {
    value: 'ignoreBlankLines',
    label: 'Ignore Blank Lines',
    toolTip: 'Ignores any line that contains only new line characters',
  },
  {
    value: 'removeQuotes',
    label: 'Remove Quotes',
    toolTip: 'Quotation marks surrounding string values are removed',
  },
  {
    value: 'truncateColumns',
    label: 'Truncate Columns',
    toolTip: 'Truncates incoming character or string data to fit width of column specification',
  },
  {
    value: 'trimBlanks',
    label: 'Trim Blanks',
    toolTip: 'Remove trailing white space from a character string',
  },
  {
    value: 'fillRecord',
    label: 'Fill Record',
    toolTip: 'Allow data to be loaded when columns are missing from the end of records',
  },
  {
    value: 'emptyAsNull',
    label: 'Empty as Null',
    toolTip: 'Empty character and string fields will be loaded as null',
    enabledByDefault: true,
  },
  {
    value: 'blanksAsNull',
    label: 'Blanks as Null',
    toolTip: 'Fields containing only white space characters will be loaded as null',
    enabledByDefault: true,
  },
  {
    value: 'escape',
    label: 'Escape',
    toolTip: 'Backslash (\\) character in files is treated as an escape character',
  },
  {
    value: 'roundec',
    label: 'Roundec',
    toolTip: 'Rounds up decimal values when scale of the input is greater than the scale of the '
           + 'column',
  },
  {
    value: 'acceptInvChars',
    label: 'Accept Invalid Characters',
    toolTip: 'Replaces invalid UTF-8 characters with question marks',
    enabledByDefault: true,
  },
  {
    value: 'csv',
    label: 'Comma Separated Values',
    toolTip: 'Enables use of CSV format in the input data',
    enabledByDefault: true,
  },
];


export default copyOptions;
